
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93SVUWLtruLwMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93pj1EzN82iaMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexQ84TJxkCQ9Meta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/blogg/index.vue?macro=true";
import { default as indexPY2TZaMZLmMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/index.vue?macro=true";
import { default as paymentj3qxLwYk0oMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientIWU6MhEBDFMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/hillceramic.se/releases/20261105104240Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as index9YBJDE0OHfMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/collections/index.vue?macro=true";
import { default as _91slug_93h6AFzKcaE4Meta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/faq/[slug].vue?macro=true";
import { default as indexzKGY7eHgaBMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexu7EaD8ZHaFMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/index.vue?macro=true";
import { default as index9d1qcBYZGFMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/login/index.vue?macro=true";
import { default as _91id_937zRqHBihLVMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/qr-pr/[id].vue?macro=true";
import { default as formQ8NkU6c1HAMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/review/form.vue?macro=true";
import { default as indexPpJsrnb2bqMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_93Iwfc0P2Qq0Meta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/shop/[...slug].vue?macro=true";
import { default as indexwefP7Eq2isMeta } from "/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___sv",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93SVUWLtruLwMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___sv",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___sv",
    path: "/blogg",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___sv",
    path: "/checkout",
    meta: indexPY2TZaMZLmMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___sv",
    path: "/checkout/payment",
    meta: paymentj3qxLwYk0oMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___sv",
    path: "/checkout/thank-you",
    meta: index_46clientIWU6MhEBDFMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___sv",
    path: "/kollektioner",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___sv",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___sv",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___sv",
    path: "/",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/index.vue")
  },
  {
    name: "login___sv",
    path: "/login",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___sv",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___sv",
    path: "/review/form",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/review/form.vue")
  },
  {
    name: "review___sv",
    path: "/review",
    meta: indexPpJsrnb2bqMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___sv",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___sv",
    path: "/track",
    meta: indexwefP7Eq2isMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105104240Z/pages/track/index.vue")
  }
]